import { Component, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'PDF Magnet';
  @ViewChild('modal') public modalComponent: ModalComponent;
  
  constructor(private titleService: Title) {
    this.titleService.setTitle(this.title);
  }

  openCaughtModal() {
    this.modalComponent.open();
  }
}